import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table'
import ReactTooltip from 'react-tooltip'
import numeral from "numeral";
import moment from "moment";
import { onAdminUpdateInvoice } from '../../store/action/invoice';
import {isAuthenticated} from "../../store/action/auth";
import InvoiceFormatter from "../../../src/screens/invoice/formatter";

const InvoiceTable = props => {
    const { token, user } = isAuthenticated();
    const col = [{
        Header: '#',
        Cell: ({row,original}) => row._index+1,
        maxWidth: 75,
        className:'text-center',
        headerClassName: 'text-center'
    },{
        Header: 'NO INVOICE',
        accessor: 'invoiceNo',
    },{
        Header: 'PERIODE',
        accessor: 'period',
    },{
        Header: 'JATUH TEMPO',
        accessor: 'dueDate',
    },{
        Header: 'TOTAL',
        accessor: 'total',
        Cell: ({row,original}) => totalCell(original)
    },{
        Header: 'STATUS',
        accessor: 'status',
        minWidth:120,
        Cell: ({row,original}) => statusCell(original)
    }];
    let columns 
    if (props.admin) {
        columns = [...col,
            {
                Header: 'Nama',
                accessor: 'name'
            },
            {
                Header: 'ACTION',
                accessor: 'action',
                minWidth:150,
                Cell: ({row,original}) => actionCell(original)
            }
        ]
    } else {
        columns = col
    }
    
    const totalCell = (og) => {
        const tax = InvoiceFormatter.defineTax(og.items)
        return (
            <div>
                Rp. {numeral(Math.abs((og.total - og.paidOrderBill) * (1 + tax.value))).format("0,0")}
            </div>
        )
    };

    const onClickAdminUpdate = async (id, type) => {
        const res = await onAdminUpdateInvoice(token, id, type)
        if (res.success) {
            alert("Berhasil update")
            window.location.reload()
        } else {
            alert("Gagal update")
        }
    }

    const actionCell = (og) => {
        return (
            <div>
                <button
                    onClick={() => onClickAdminUpdate(og.id, 'confirm')} 
                    className="badge badge-info border border-info pointer ml-3"
                >
                    Konfirmasi
                </button>
                <button
                    onClick={() => onClickAdminUpdate(og.id, 'void')} 
                    className="badge badge-info border border-info pointer ml-3"
                >
                    Void
                </button>
                <br/>
                {
                    og.status === 'paid' ? null :
                    <button
                        onClick={() => onClickAdminUpdate(og.id, 'delete')} 
                        className="badge badge-danger border border-danger pointer ml-3"
                    >
                        Hapus
                    </button>
                }
              
                { 
                    !og.imageUrl ? null :
                    <button
                        className="badge badge-info border border-info pointer ml-3"
                        onClick={() => window.open(og.imageUrl)}
                    >
                        Bukti Bayar
                    </button>
                } 
            </div>
        )
    };

    const statusCell = (og) => {
        let status;
        let link = props.admin ? `/invoices/${og.id}` : `invoices/${og.id}`
        if (og.status === 'due') {
            status = (
                <div className="text-danger">
                    <b>Jatuh Tempo</b>
                    <Link to={link}>
                        <button className="badge badge-danger border border-danger pointer ml-3">
                            Bayar
                        </button>
                    </Link>
                </div>
            )
        } else if (og.status === 'paid') {
            status = (
                <div className="text-success">
                    <b>Lunas</b>
                    <Link to={`invoices/${og.id}`}>
                        <button className="badge badge-success border border-success pointer ml-3">
                            Detail
                        </button>
                    </Link>
                </div>
            )
        } else if (og.status === 'active') {
            status = (
                <div className="text-danger">
                    Aktif
                    <Link to={link}>
                        <button className="badge badge-danger border border-danger pointer ml-3">
                            Bayar
                        </button>
                    </Link>
                </div>
            )
        } else if (og.status === 'pending') {
            status = (
                <div className="text-warning">
                    Waiting
                    <Link to={`invoices/${og.id}`}>
                        <button className="badge badge-warning border border-warning pointer ml-3">
                            Detail
                        </button>
                    </Link>
                  
                </div>
            )
        } else if (og.status === 'void') {
            status = (
                <div className="text-muted">
                    Void
                </div>
            )
        } 

        return (
            <div>
                {status}
            </div>
        )
    };


    return (
        <div>
            <ReactTable
                data={props.data}
                columns={columns}
                defaultPageSize={props.admin ? 50 : 10}
                filterable
                loading={props.loading}
                className="-striped -highlight"
            />
        </div>
    )
};

export default InvoiceTable;
